var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPhone = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.92237 1.25767L2.70822 0.811394C3.44603 0.393199 4.37491 0.623993 4.88133 1.3498L5.88736 2.79632C6.32538 3.42613 6.33418 4.27363 5.90724 4.89139L4.72006 6.61056C4.98783 7.43391 5.44539 8.2035 6.0912 8.91965C6.7078 9.61432 7.45752 10.1782 8.29597 10.5779L9.95214 9.60874C10.5806 9.24212 11.3702 9.34685 11.9114 9.86835L13.1744 11.0827C13.8045 11.6893 13.9233 12.6829 13.4519 13.4081L12.9465 14.1854C12.4435 14.9589 11.5818 15.3827 10.6849 15.2964C8.56685 15.0939 6.35288 13.6371 4.04226 10.9261C1.7283 8.21092 0.592132 5.73231 0.635194 3.49322C0.6531 2.55101 1.14228 1.70027 1.92237 1.25767Z",
    fill: "#A8B1C1"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPhone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/phone.dbdc8392f0fbe941a2d7d61fc855e289.svg";